(function($) {

    $.fn.msxiRotateCell = function() {

        return this.each(function() {
            var $this = $(this);

            var display = $this.css('display');
            $this.css({height: 'auto', width: 'auto'});
            var width = $this.outerHeight();
            $this.css('display', 'inline');
            var height = $this.outerWidth();
            $this.css('display', display);
            $this.css({height: height, width: width});
        });
    };

})(jQuery);
